var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import cx from "clsx";
import { ItemImage } from "./ItemImage";
import { ItemChip } from "./ItemChip";
import { ItemTitle } from "./ItemTitle";
import { ItemSubtitle } from "./ItemSubtitle";
import { ItemTextContainer } from "./ItemTextContainer";
export var Item = function (_a) {
    var title = _a.title, url = _a.url, subtitle = _a.subtitle, chip = _a.chip, image = _a.image, isAlternative = _a.isAlternative;
    var baseClass = "flex justify-start items-stretch last:mb-0 px-4 md:px-0 md:py-0 text-text-primary group";
    var typeClass = isAlternative ? "py-0 mt-5 mb-5 md:mt-0" : "flex-wrap py-3 mb-2 md:mb-8";
    var commonProps = {
        isAlternative: isAlternative,
        hasChip: Boolean(chip),
    };
    return (React.createElement("a", { href: url, className: cx(baseClass, typeClass) },
        React.createElement(ItemImage, { image: image, isAlternative: isAlternative, title: title }),
        React.createElement(ItemTextContainer, __assign({}, commonProps),
            React.createElement(ItemTitle, __assign({ title: title }, commonProps)),
            subtitle && React.createElement(ItemSubtitle, { subtitle: subtitle }),
            chip && React.createElement(ItemChip, { chip: chip }))));
};
//# sourceMappingURL=Item.js.map